import { useHeaderHeight } from '@react-navigation/elements'
import type { ReactNode } from 'react'
import { Platform, StyleSheet, View } from 'react-native'
import { useTheme } from 'react-native-paper'

interface ListWrapperProps {
    children: ReactNode
}

export function ListWrapper({ children }: ListWrapperProps) {
    const theme = useTheme()
    const headerHeight = useHeaderHeight()

    return (
        <View
            style={[
                styles.container,
                {
                    backgroundColor: theme.colors.background,
                    paddingTop: Platform.OS === 'ios' ? headerHeight : 0,
                },
            ]}
        >
            {children}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
})
